import styled, { css } from 'styled-components'
// icons
import LogicIconOrigin from 'src/icons/logic-unsellected.svg'
import LogicSelectedOrigin from 'src/icons/logic-selected.svg'

const IconCSS = css<{ color: string }>`
  margin: 0 !important;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }

  path {
    fill: ${({ color }) => color};
  }
`

export const LogicIcon = styled(LogicIconOrigin)<any & { color?: string }>`
  height: 46px;
  width: 46px;

  ${IconCSS};
`

export const LogicSelectedIcon = styled(LogicSelectedOrigin)<any & { color: string }>`
  height: 46px;
  width: 46px;

  ${IconCSS};
`
